import { call, all, put, takeLatest } from 'redux-saga/effects';
import { Types, fulfill, failed, request, success } from '../ducks';
import { getAssociatis } from '../../../../services';

function* loadAssociatis() {
  yield put(request());
  try {
    const { data } = yield call(getAssociatis);
    if (data) {
      yield put(success(data));
    }
  } catch (error) {
    yield put(failed(error));
  } finally {
    yield put(fulfill());
  }
}

export default function* associatisSaga() {
  yield all([
    takeLatest(Types.TRIGGER, loadAssociatis)
  ]);
}
